import React, { useState } from "react";
import { Link } from "react-router-dom";
import ImageOne from "../../images/steel-image/one.jpg";
import ImageTwo from "../../images/steel-image/two.jpg";
import ImageThree from "../../images/steel-image/three.jpeg";
import ImageFour from "../../images/steel-image/four.jpg";
import ImageFive from "../../images/steel-image/five.jpg";

const SteelDivisiontwo = () => {
    return (
        <div className="w-full mx-auto py-4 sm:px-0 md:px-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                {/* Box 1 */}
                <Box 
                    image={ImageOne} 
                    title="Structural Steel"
                    items={["Label", "Label", "Label"]}
                    link="/contact"
                />

                {/* Box 2 */}
                <Box 
                    image={ImageTwo} 
                    title="Steel Pipes & Tubes"
                    items={["Label", "Label", "Label"]}
                    link="/services"
                />

                {/* Box 3 */}
                <Box 
                    image={ImageThree} 
                    title="Steel Sheets & Coils"
                    items={["Label", "Label", "Label"]}
                    link="/products"
                />

                {/* Box 4 */}
                <Box 
                    image={ImageFour} 
                    title="Reinforcement Steel (Rebar)"
                    items={["Label", "Label", "Label"]}
                    link="/services"
                />

                {/* Box 5 */}
                <Box 
                    image={ImageFive} 
                    title="Steel Wire & Coatings"
                    items={["Label", "Label", "Label"]}
                    link="/services"
                />
            </div>
        </div>
    );
};

const Box = ({ image, title, items, link }) => {
    const [bgColor, setBgColor] = useState("transparent");

    return (
        <div className="flex flex-col bg-white rounded-lg overflow-hidden p-4 duration-300 ease-in-out group">
            {/* Image container with zoom effect */}
            <div className="overflow-hidden rounded-md">
                <img
                    src={image}
                    alt={title}
                    className="w-full h-[260px] object-cover rounded-md transform group-hover:scale-110 transition duration-300 ease-in-out"
                />
            </div>

            {/* Content Section */}
            <div className="flex-grow">
                <h2 className="text-2xl md:text-3xl font-semibold mt-4 h-[60px] overflow-hidden">
                    {title}
                </h2>
                <ul className="text-gray-600 mt-2 text-base md:text-lg space-y-2 list-none">
                    {items.map((item, index) => (
                        <li key={index} className="flex items-center">
                            <span className="mr-3 text-xl md:text-2xl leading-none">•</span>
                            {item}
                        </li>
                    ))}
                </ul>
            </div>

            {/* Button */}
            <Link to={link}>
                <button
                    className="px-3 py-1 w-full mt-9 border-2 border-[#0C2340] text-[#0C2340] hover:text-white font-semibold rounded-lg transition duration-300"
                    style={{ backgroundColor: bgColor }}
                    onMouseEnter={() => setBgColor("#1B365D")}
                    onMouseLeave={() => setBgColor("white")}
                >
                    VIEW ALL
                </button>
            </Link>
        </div>
    );
};

export default SteelDivisiontwo;
